import * as t from "react";
import { forwardRef as o } from "react";
const s = o(function(e, r) {
  return /* @__PURE__ */ t.createElement(
    "svg",
    {
      fill: "none",
      ref: r,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...e
    },
    /* @__PURE__ */ t.createElement("circle", { cx: 12, cy: 11, r: 5, stroke: "currentColor", strokeWidth: 2 }),
    /* @__PURE__ */ t.createElement("path", { d: "M12 16V19", stroke: "currentColor", strokeWidth: 2 })
  );
});
export {
  s as Finishingpost
};
